import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJObjectEraseRight.module.less';

import FJUtil from '../../../../util/FJUtil';
import FJConstant from '../../../../constants/FJConstant';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJCreationEditPanelContainer from '../../../FJMainPreview/FJCreationEditPanel/container/FJCreationEditPanelContainer';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJBlankInVideoPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';

const FJObjectEraseRight = props => {
    const {
        setIsDraggingFile,
        uploadImg,
        headerTabIndex,
        taskStatus,
        downloadEditImageLoading,
        isCanDownload,
        download,
        isNotImage,
        hasEditImage,
    } = props;

    const renderDownload = () => {
        if (
            FJUtil.isGeneratingStatus(taskStatus) ||
            taskStatus === FJConstant.ERROR ||
            headerTabIndex !== 0 ||
            !isCanDownload
        ) {
            return <div />;
        }

        if (window.isEditPage) return null; // 使用内部的download组件

        return (
            <div className={styles.download_box}>
                <FJButton
                    className={classNames(styles.download_btn, downloadEditImageLoading && styles.loading)}
                    type={FJButtonType.GRADIENT}
                    icon={<FJDownloadIcon className={styles.download_btn_icon} />}
                    text='download'
                    onClick={download}
                    textClassName={styles.download_btn_text}
                    isLoading={downloadEditImageLoading}
                />
            </div>
        );
    };

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            uploadFile={uploadImg}
            className={classNames(styles.app_right, headerTabIndex === 0 ? styles.creations_box : '')}
        >
            <FJDisplayHeaderContainer
                isShowProgress={false}
                rightChildren={renderDownload()}
                hasEditImage={hasEditImage}
            />

            {isNotImage ? (
                <FJBlankInVideoPanel
                    active={headerTabIndex === 0}
                    boxDesc='remove-objects-efficiently-create-images-professionally'
                    boxTitle='quickly-remove-unwanted-objects-using-ai'
                />
            ) : (
                <FJCreationEditPanelContainer activeHeaderTabIndex={0} />
            )}

            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJObjectEraseRight.propTypes = {
    setIsDraggingFile: PropTypes.func,
    uploadImg: PropTypes.func,
    headerTabIndex: PropTypes.number,
    taskStatus: PropTypes.string,
    creationList: PropTypes.array,
    downloadEditImageLoading: PropTypes.bool,
    download: PropTypes.func,
    isNotImage: PropTypes.bool,
    isCanDownload: PropTypes.bool,
    hasEditImage: PropTypes.bool,
};

export default FJObjectEraseRight;
